import PropTypes from 'prop-types';
import React from 'react';

import {ArchivedFilter} from '@utils/commonFilters/ArchivedFilter';
import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';

const RtmpOriginStreamNamesFilter = ({
    loading,
    filters,
    restoreFilterValues,
}) => {
    return (
        <div className='rtmpOriginStreamNames__filters filter__controls__container'>
            <SearchFilter
                loading={loading}
                filters={filters.rtmpOriginStreamNames}
                restoreFilterValues={restoreFilterValues}
            />
            <ArchivedFilter
                loading={loading}
                filters={filters}
                filterKey='rtmpOriginStreamNames'
                restoreFilterValues={restoreFilterValues}
            />
        </div>
    );
};

RtmpOriginStreamNamesFilter.propTypes = {
    data: PropTypes.shape({
        isArchived: PropTypes.array,
    }),
    loading: PropTypes.bool.isRequired,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(RtmpOriginStreamNamesFilter, {name: 'rtmpOriginStreamNames', initialValues: {isArchived: 0}});
